




















import { UiTooltip } from '../keen-ui';

export default {
  name: 'instance-card',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    UiTooltip
  },
  computed: {
    logoUrl: function (): string {
      return ((!!this.instance.logoUrls && this.instance.logoUrls.imagotype) ||
        `${ this.assetsBaseUrl }/${ this.instance.instanceId }/logo.svg`);
    },
    name: function (): string {
      return (this.instance.prettyName || this.instance.instanceId);
    }
  },
  data: function () {
    return {
      logoIsValid: true,
      assetsBaseUrl: 'https://assets.empathybroker.com/resources/media/customers'
    };
  }
};
